export default __webpack_public_path__ + "8f541c5a606995661b67e8d805473ef2.svg";